import { ApolloLink, ApolloProvider } from "@apollo/client";
import * as React from "react";
import ReactDOM from "react-dom";
import { ApolloProvider as ApolloHooksProvider } from "@apollo/client";
import { BrowserRouter, HashRouter } from "react-router-dom";

import "styles/index.scss";

import { usesHashRouter } from "utilities/environment";
import { getJwt } from "utilities/authentication";

import { createClient } from "../../apollo";
import App from "./App";

const matchOrgId = usesHashRouter()
  ? /https?:\/\/[^#]+#\/([0-9a-f-]{36})(\/)?/
  : /https?:\/\/.+(?:gopinata\.com|letsgopinata\.com|gohayday\.co|gopronto\.info)\/([0-9a-f-]{36})(\/)?/;

const organizationLink = new ApolloLink((operation, forward) => {
  const match = location.href.match(matchOrgId);
  if (match && match.length > 0) {
    const context = operation.getContext();
    const headers = (context && context.headers) || {};
    if (match[1]) {
      context.headers["X-Pinata-Organization-Id"] = match[1];
    }
    operation.setContext({ headers });
  }
  return forward ? forward(operation) : null;
});

const client = createClient("nacho", getJwt, [organizationLink]);

const Router: React.ComponentType<{}> = usesHashRouter() ? HashRouter : BrowserRouter;

function Root() {
  return (
    <ApolloProvider client={client}>
      <ApolloHooksProvider client={client}>
        <Router>
          <App client={client} />
        </Router>
      </ApolloHooksProvider>
    </ApolloProvider>
  );
}

ReactDOM.render(<Root />, document.getElementById("root"));
